import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/Effet_Mer/Effet_Mer-hero.jpg";
import ImgheroMobile from "../../../assets/img/projects/Effet_Mer/Effet_Mer-hero-mobile.png";
import Logo from "../../../assets/img/projects/Effet_Mer/Effet_Mer-logo.svg";
import { useTranslation } from "react-i18next";
import { useState, useLayoutEffect } from "react";

export default function Hero() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const heroStyle = {
    backgroundImage: `url(${isMobile ? ImgheroMobile : Imghero})`,
  };

  return (
    <div className="Effet_Mer hero" id="hero" style={heroStyle}>
      <Nav />
      <img className="ImgHero" src={Logo} alt="Effet Mer Logo" />
      <HeroFooter
        name="Effet Mer"
        link1url="https://effetmerplage.fr/"
        link2display={false}
        link2name={t("effetMer.hero.link2")}
        link2url="https://www.instagram.com/effetmerplage/?hl=fr"
      />
    </div>
  );
}
